import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-meu-link',
  templateUrl: './meu-link.component.html',
  styleUrls: ['./meu-link.component.css']
})
export class MeuLinkComponent implements OnInit {

  constructor() { }
  @Input()link:any;
  @Input()texto:any;
  ngOnInit() {
  }

}
